export const trackingAndDriverDetailsCode = {
  response: {
    "If Failed Request": {
      success: false,
      driverData: {
        name: "John",
        countryCode: "+91",
        contactNumber: "123456789",
      },
      message: "Tracking Link not yet generated",
    },

    
    "If Successful Request": {
      success: true,
      driverData: {
        name: "John",
        countryCode: "+91",
        contactNumber: "123456789",
      },
      trackingLink:
        "https://testapi.drivado.com/api/v1/api/trackingLink?bookingId=D1223-P5Y4Q",
    },
  },
};

export const trackingAndDriverDetailsCodeImplementation = {
  nodejs_Axios: `
  const axios = require('axios');
  
  let config = {
    method: 'get',
    maxBodyLength: Infinity,
    url: 'https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=D0824-2262&email=W1user1@email.com',
    headers: { 
      'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
    }
  };
  
  axios.request(config)
  .then((response) => {
    console.log(JSON.stringify(response.data));
  })
  .catch((error) => {
    console.log(error);
  });
  `,
  python: `
  import requests
  
  url = "https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=D0824-2262&email=W1user1@email.com"
  
  headers = {
    'apikey': 'iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
  }
  
  response = requests.request("GET", url, headers=headers)
  
  print(response.text)
  `,
  go: `
  package main
  
  import (
    "fmt"
    "io/ioutil"
    "net/http"
  )
  
  func main() {
    url := "https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=D0824-2262&email=W1user1@email.com"
    req, _ := http.NewRequest("GET", url, nil)
  
    req.Header.Add("apikey", "iL9e30CjZfRok2FuH6KC1xuqCa7C3K")
  
    res, _ := http.DefaultClient.Do(req)
  
    defer res.Body.Close()
    body, _ := ioutil.ReadAll(res.Body)
  
    fmt.Println(string(body))
  }
  `,
  curl: `
  curl --location --request GET 'https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=D0824-2262&email=W1user1@email.com' \\
  --header 'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
  `,
  php: `
  <?php
  
  $curl = curl_init();
  
  curl_setopt_array($curl, array(
    CURLOPT_URL => 'https://testapi.drivado.com/api/v1/api/apiDriverTracking?bookingId=D0824-2262&email=W1user1@email.com',
    CURLOPT_RETURNTRANSFER => true,
    CURLOPT_ENCODING => '',
    CURLOPT_MAXREDIRS => 10,
    CURLOPT_TIMEOUT => 0,
    CURLOPT_FOLLOWLOCATION => true,
    CURLOPT_HTTP_VERSION => CURL_HTTP_VERSION_1_1,
    CURLOPT_CUSTOMREQUEST => 'GET',
    CURLOPT_HTTPHEADER => array(
      'apikey: iL9e30CjZfRok2FuH6KC1xuqCa7C3K'
    ),
  ));
  
  $response = curl_exec($curl);
  
  curl_close($curl);
  echo $response;
  ?>
  `,
};
